import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import client from "@/lib/api";
import { translations } from "@/lib/i18n";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=checking, null=guest
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");
  const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "light");

  useEffect(() => {
    const html = document.documentElement;
    html.dir = lang === "ar" ? "rtl" : "ltr";
    html.lang = lang;
    localStorage.setItem("lang", lang);
  }, [lang]);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("theme", theme);
  }, [theme]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setUser(null); return; }
    client.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("token"); setUser(null); });
  }, []);

  const login = async (email, password) => {
    const { data } = await client.post("/auth/login", { email: email.trim(), password: password.trim() });
    localStorage.setItem("token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => { localStorage.removeItem("token"); setUser(null); window.location.href = "/login"; };

  const t = useCallback((key) => translations[lang]?.[key] || translations.en[key] || key, [lang]);

  const can = (roles) => {
    if (!user) return false;
    if (user.role === "super_admin") return true;
    return roles.includes(user.role);
  };

  return (
    <AppContext.Provider value={{ user, setUser, login, logout, lang, setLang, theme, setTheme, t, can, isRTL: lang === "ar" }}>
      {children}
    </AppContext.Provider>
  );
}
